import { useClientConfigProvider } from "@/app/config/client-config-provider";
import Image from "next/image";
import { useState } from "react";

export default function SearchItemRecent({
  name,
  onCloseClick,
  onClickItem,
}: {
  name: string;
  onCloseClick?: Function;
  onClickItem?: Function;
}) {
  const { getImagePath } = useClientConfigProvider();
  return (
    <div className="search-item-recent">
      <div
        className="search-recent-text c-pointer"
        onClick={() => {
          if (onClickItem != null) onClickItem();
        }}
      >
        <Image
          src={getImagePath("search_in_item.png")}
          alt="Search Icon"
          width={24}
          height={24}
        />
        <div className="w-100">{name} </div>
      </div>

      <Image
        className="c-pointer"
        src={getImagePath("close.png")}
        alt="Search Icon"
        width={24}
        height={24}
        onClick={() => {
          if (onCloseClick != null) onCloseClick();
        }}
      />
    </div>
  );
}
